<template>
	<div class="view-wrapper">
		<div 	class="view-container"
				v-if="coupon !== null && error == null">
			<b-container class="no-padding">
				<b-row>
					<b-col 	md="6"
							sm="12">
						<p><h3 class="vrnu-headline">{{ coupon.provider.name }}</h3></p>	
						<b-container>
							<b-row>
								<b-col 	lg="6"
										md="12">
											<b-img v-bind:src="coupon.provider.brandImage.secure_url" fluid alt="Logo" />
										</b-col>
								<b-col 	lg="6"
										md="12">
											<h4 class="text-underlined">Aktiv</h4>
											<span v-if="coupon.provider.active">
												<span class="icon-check text-green"></span> Der Anbieter ist aktiv und wird in der App angezeigt
											</span>
											<span v-else>
												<span class="icon-cancel text-red"></span> Der Anbieter ist nicht aktiv und wird in der App nicht angezeigt
											</span>
											<div class="space30"></div>
											<h4 class="text-underlined">Kategorie</h4>
											<span>{{ options[coupon.provider.category] }}</span>
											<div class="space30"></div>
										</b-col>
							</b-row>
						</b-container>
						<div class="space30"></div>							
					</b-col>
					<b-col 	md="6"
							sm="12">
						<p><h3 class="vrnu-headline">{{ coupon.title }}</h3></p>
						<b-container class="no-padding">
							<b-row>
								<b-col 	lg="6"
										md="12">
									<h4 class="text-underlined">Beschreibung</h4>
									<span>{{ coupon.description }}</span>
									<div class="space30"></div>							
								</b-col>
								<b-col 	lg="6"
										md="12"
										v-if="coupon.validFrom !== null || coupon.validTo !== null">
									<h4 class="text-underlined">Gültigkeit</h4>
									<span>Gültig ab: {{ moment(coupon.validFrom).format("DD.MM.YYYY") }}</span>
									<br>
									<span>Gültig bis: {{ moment(coupon.validTo).format("DD.MM.YYYY") }}</span>
									<div class="space30"></div>
								</b-col>
							</b-row>
							<b-row>
								<b-col 	lg="6"
										md="12"
										v-if="coupon.ageFrom !== null || coupon.ageTo !== null">
									<h4 class="text-underlined">Altersgruppe</h4>
									<span v-if="coupon.ageFrom !== null">Mindestalter: {{ coupon.ageFrom }}<br></span>
									<span v-if="coupon.ageTo !== null">Maximalalter: {{ coupon.ageTo }}</span>
									<div class="space30"></div>
								</b-col>
								<b-col 	lg="6"
										md="12">
									<h4 class="text-underlined">Aktiv</h4>
									<span v-if="coupon.active">
										<span class="icon-check text-green"></span> Der Gutschein ist aktiv und wird in der App angezeigt
									</span>
									<span v-else>
										<span class="icon-cancel text-red"></span> Der Gutschein ist nicht aktiv und wird in der App nicht angezeigt
									</span>
									<div class="space30"></div>
								</b-col>
							</b-row>
						</b-container>
					</b-col>
				</b-row>
			</b-container>
		</div>
		<div v-else>
			<b-alert show variant="danger">{{ error }}</b-alert>
		</div>
	</div>
</template>

<script>
// Organize imports
var moment = require('moment');

export default {
	data: function() {
		return {
			coupon: null,
			error: null,
			options: {
				leisure: 'Freizeit',
				sports: 'Sport',
				shops: 'Shopping',
				season: 'Saisonales',
				food: 'Essen & Getränke', 	
			},
		};
	},
	methods: {
		getCoupon: function() {
			// Get the coupon
			this.$http.get('coupons/' + this.objectId).then(result => {
				this.coupon = result.body;
			}, response => {
				this.error = "Beim Laden des Anbieters ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		closeModal: function() {
			this.$emit('closeModal');
		},
		moment: function(date) {
			return moment(date);
		},
	},
	mounted: function() {
		// Load coupon from database
		this.getCoupon();
	},
	props: {
		objectId: {
			required: true,
		}
	},
}
</script>

<style>
.form-container {
	padding: 5px;
}
.text-underlined {
	text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/04_coupon/CouponsView.vue